export default __webpack_public_path__ + "static/media/html.b9071dd7.svg";